<template>
  <div class="additional-report">
      <div class="d-flex">
          <div class="mt-2 mr-2">
              <el-button-group>
                  <el-button :disabled="disabledDate" :type="type===0 ? 'primary' : 'default'" size="mini" @click="changeTimeByType(0)">Ngày</el-button>
                  <el-button :disabled="disabledDate" :type="type===1 ? 'primary' : 'default'" size="mini" @click="changeTimeByType(1)">Tuần</el-button>
                  <el-button :disabled="disabledDate" :type="type===2 ? 'primary' : 'default'" size="mini" @click="changeTimeByType(2)">Tháng</el-button>
                  <el-button :disabled="disabledDate" :type="type===3 ? 'primary' : 'default'" size="mini"  @click="changeTimeByType(3)">Giai đoạn</el-button>
              </el-button-group>
          </div>
          <div class="date-trigger-wrap mt-2">
              <button class="calendar-trigger" @click="openPicker('resultPicker')">
                  <i class="el-icon-date"></i>
              </button>
              <el-date-picker
                  ref="resultPicker"
                  v-model="date"
                  :type="pickerType"
                  :placeholder="pickerPlaceholder"
                  :format="displayFormat"
                  :value-format="valueFormat"
                  :picker-options="pickerOptions"
                  :clearable="false"
                  :editable="false"
                  append-to-body
                  class="invisible-picker"
                  @change="onPick"
              />
          </div>
      </div>

      <div class="d-flex justify-space-around">
          <el-select
              v-if="[6].includes(keyAccount)"
              v-model="area_id" placeholder="Chọn Khu vực" filterable collapse-tags clearable
              class="w-100 mt-2 mr-2">
              <el-option v-for="item in areas" :key="item.id" :label="item.name" :value="item.id"/>
          </el-select>
          <el-select v-if="[5].includes(keyAccount)" v-model="branch_id" placeholder="Chọn văn phòng" filterable clearable
                     class="w-100 mt-2">
              <el-option v-for="item in branches" :key="item.id" :label="item.name_alias || item.name" :value="item.id"/>
          </el-select>
      </div>

      <div slot="footer" class="d-flex justify-content-end mt-4">
          <el-button @click="close">Hủy</el-button>
          <el-button type="primary" @click="create">Xác nhận</el-button>
      </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {CREATE_ADDITIONAL_IMPORTANT_WORK} from "@/core/services/store/contract/contractOnline.module";

export default {
  name: 'AdditionalReport',
  props: {
    areas: {
      type: Array,
      required: true
    },

    branches: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
     area_id: null,
     branch_id: null,
     type: 0,
     date: this.today(),
     disabledDate: false
    };
  },
  methods: {
      today() {
          const d = new Date();
          const y = d.getFullYear();
          const m = ('0' + (d.getMonth()+1)).slice(-2);
          const day = ('0' + d.getDate()).slice(-2);
          return `${y}-${m}-${day}`;
      },

      changeTimeByType(t) {
          this.disabledDate = true;
          this.type = t;

          const fmt = (dt) => {
              const y = dt.getFullYear();
              const m = String(dt.getMonth() + 1).padStart(2, '0');
              const d = String(dt.getDate()).padStart(2, '0');
              return `${y}-${m}-${d}`;
          };

          const parseSeed = (input) => {
              let s = input;
              if (Array.isArray(s) && s[0]) s = s[0];

              if (s instanceof Date) {
                  return { y: s.getFullYear(), m: s.getMonth() + 1, d: s.getDate() };
              }

              if (typeof s === 'string') {
                  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
                      const [y, m, d] = s.split('-').map(Number);
                      return { y, m, d };
                  }
                  if (/^\d{4}-\d{2}$/.test(s)) {
                      const [y, m] = s.split('-').map(Number);
                      return { y, m, d: 1 };
                  }
              }
              return null;
          };

          if (t === 0) {
              // Hôm nay -> string
              const today = new Date();
              this.date = fmt(today);

          }else if (t === 1) {
              const todayStr = fmt(new Date());
              const parsed = parseSeed(this.date) || parseSeed(todayStr);
              const { y, m, d } = parsed;

              const base = new Date(y, m - 1, d);
              const dow = base.getDay() === 0 ? 7 : base.getDay();   // Mon=1..Sun=7
              const start = new Date(base); start.setDate(base.getDate() - (dow - 1)); // Mon
              const end   = new Date(start); end.setDate(start.getDate() + 6);         // Sun
              const monthStart = new Date(y, m - 1, 1);
              const monthEnd   = new Date(y, m, 0);
              const clampStart = start < monthStart ? monthStart : start;
              const clampEnd   = end   > monthEnd   ? monthEnd   : end;
              this.date = [fmt(clampStart), fmt(clampEnd)];
          }else if (t === 2) {
              let y, m;
              const parsed = parseSeed(this.date);

              if (parsed) {
                  y = parsed.y;
                  m = parsed.m;
              } else {
                  const today = new Date();
                  y = today.getFullYear();
                  m = today.getMonth() + 1;
              }
              const first = new Date(y, m - 1, 1);
              this.date = fmt(first);
          }else if (t === 3) {
              const today = new Date();
              const currentYear = today.getFullYear();
              const currentMonth = today.getMonth();

              let firstThursday = new Date(currentYear, currentMonth, 1);
              while (firstThursday.getDay() !== 4) {
                  firstThursday.setDate(firstThursday.getDate() + 1);
              }

              const nextThursday = new Date(firstThursday);
              nextThursday.setDate(firstThursday.getDate() + 7);

              this.date = [fmt(firstThursday), fmt(nextThursday)];
          }
          this.disabledDate = false;
      },
      create() {
          try {
              const payload = {
                    user_id: this.currentUser.id,
                    area_id: this.area_id,
                    branch_id: this.branch_id,
                    type: this.type,
                    date: this.date
              };
              const check = this.validatePayload(payload);
              if(!check) return;
              this.$store.dispatch(CREATE_ADDITIONAL_IMPORTANT_WORK, payload).then(res => {
                    this.$emit('reload');
                    this.$emit('close');
              })
          } catch (e) {
              this.$message.error('Lưu thất bại.');
          } finally {
              this.saving = false;
          }
      },

      validatePayload(payload) {
          const notify = (msg) =>
              this.$notify({ title: 'Thiếu dữ liệu!', message: msg, type: 'warning' });

          const isEmpty = (v) =>
              v === null || v === undefined || (typeof v === 'string' && v.trim() === '');

          if (!payload || typeof payload !== 'object') {
              notify('Dữ liệu không hợp lệ!');
              return false;
          }

          const required = ['date'];
          if ([6].includes(this.keyAccount)) required.push('area_id');
          if ([5].includes(this.keyAccount)) required.push('branch_id');

          const messages = {
              date: 'Vui lòng chọn ngày báo cáo!',
              area_id: 'Vui lòng chọn khu vực!',
              branch_id: 'Vui lòng chọn văn phòng!',
          };

          for (const field of required) {
              if (isEmpty(payload[field])) {
                  notify(messages[field] || `Thiếu trường: ${field}`);
                  return false;
              }
          }
          return true;
      },
      onPick(val) {
          if (this.type === 1 && val) {
              const [y, m, d] = String(val).split('-').map(Number);
              const base = new Date(y, m - 1, d);
              const dow = base.getDay() === 0 ? 7 : base.getDay(); // 1..7 (Mon..Sun)
              const start = new Date(base); start.setDate(base.getDate() - (dow - 1)); // Monday
              const end   = new Date(start); end.setDate(start.getDate() + 6);        // Sunday


              const monthStart = new Date(y, m - 1, 1);
              const monthEnd   = new Date(y, m, 0);


              const clampStart = start < monthStart ? monthStart : start;
              const clampEnd   = end   > monthEnd   ? monthEnd   : end;

              const fmt = (dt) =>
                  `${dt.getFullYear()}-${String(dt.getMonth()+1).padStart(2,'0')}-${String(dt.getDate()).padStart(2,'0')}`;
              this.date = [fmt(clampStart), fmt(clampEnd)];
          }
      },
      openPicker() {
          this.$nextTick(() => {
              const dp = this.$refs.resultPicker;
              if (!dp) return;

              if (typeof dp.focus === 'function') {
                  dp.focus();
              } else if (typeof dp.handleFocus === 'function') {
                  dp.handleFocus();
              } else {
                  try { dp.pickerVisible = true; } catch (e) {}
                  const input = dp.$refs?.reference?.$refs?.input || dp.$el?.querySelector?.('input');
                  if (input) input.focus();
              }
          });
      },
      close() {
          this.$emit('close');
      }

  },
  mounted() {
      console.log('keyAccount', this.keyAccount);
  },

    computed: {
        ...mapGetters(['currentUser', 'keyAccount']),
        pickerType() { return this.type === 0 ? 'date' : this.type === 1 ? 'week' : this.type === 2 ? 'month' : 'daterange'; },
        valueFormat() { return this.type === 2 ? 'yyyy-MM' : 'yyyy-MM-dd'; },
        displayFormat() { return this.type === 0 ? 'dd/MM/yyyy' : this.type === 1 ? 'dd/MM/yyyy' : 'MM/yyyy'; },
        pickerPlaceholder() { return this.type === 0 ? 'Chọn ngày' : this.type === 1 ? 'Chọn tuần' : 'Chọn tháng'; },
        pickerOptions() { return this.type === 1 ? { firstDayOfWeek: 1 } : {}; },
    }
};
</script>

<style scoped>
.date-trigger-wrap { position:relative; display:inline-flex; align-items:center; }
.calendar-trigger { display:inline-flex; align-items:center; gap:8px; border:0; background:transparent; cursor:pointer; padding:4px 6px; border-radius:8px; transition:background .15s; }
.calendar-trigger .el-icon-date { font-size:18px; color:#22c55e; }
.calendar-trigger:hover { background:#f3f4f6; }
.invisible-picker { width:0!important; height:0!important; opacity:0!important; position:absolute!important; pointer-events:none!important; }
</style>
